module.exports = __webpack_public_path__ + "img/logo-payje.608d64ed.svg";